var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{ref:"box",staticClass:"base-autocomplete",attrs:{"cy":"autocomplete-box"}},_vm._l((_vm.list),function(item,idx){return _c('li',{key:idx,class:{highlight: _vm.index === idx},on:{"mousedown":function($event){return _vm.select($event, item)}}},[_vm._v(" "+_vm._s(_vm.getLabel(item))+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }